// Unbenannte Posten heißen wie auf der Rechnung „Kursgebühr“, nie „Rate“ oder „Automatisch“ (Entscheidung 30.10.2026);
// Rabatt-Raten aus dem Ratenplan „Rabatt“ wie im Jahresexport, alles andere „Zusatzposten“.
export const unnamedPostLabel = (type?: string | null): string => {
    if (!type || type === "Standard") {
        return "Kursgebühr";
    }

    return type === "Discount" ? "Rabatt" : "Zusatzposten";
};
